export const customerHeader = [
  {
    id: 1,
    value: 'Local da transação',
    maxChar: 10,
    textAlign: 'center',
  },
  {
    id: 2,
    value: 'Valor da parcela',
    maxChar: 20,
    textAlign: 'center',
  },
  {
    id: 3,
    value: 'Valor da compra',
    maxChar: 20,
    textAlign: 'center',
  },
  {
    id: 4,
    value: 'Tipo de transação',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 5,
    value: 'Origem',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 6,
    value: 'Fatura',
    maxChar: 10,
  },
  {
    id: 7,
    value: 'Data e hora transação',
    maxChar: 30,
    textAlign: 'center',
  },
  {
    id: 8,
    value: 'Ação',
    maxChar: 10,
    textAlign: 'center',
  },
];

export const TYPES_TRANSACTION = [
  {
    id: 'TODOS',
    name: 'Todos',
    value: 'Todos',
  },
  {
    id: 'PADRAO',
    name: 'Limite Convênio Multi',
    value: 'Limite Convênio',
  },
  {
    id: 'LIMITE_EXTRA',
    name: 'Saldo Vale-compras',
    value: 'Saldo Vale-compras',
  },
];
